if (!customElements.get('sticky-nav')) {
  class StickyNav extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.closest('.section-sticky-nav');
      this.links = [...this.querySelectorAll('a')];
      this.scrollContainer = this.querySelector('[data-scroll]');
      this.scrollArrows = {
        left: this.querySelector('[data-scroll-left]'),
        right: this.querySelector('[data-scroll-right]')
      };
      this.tracker = this.querySelector('[data-tracker]');
      this.pageHeader = document.querySelector('sticky-header');
      this.scrollAmount = 140;
      this.sections = this.links.map(link => document.querySelector(link.getAttribute('href')));

      this.bindMethods();
    }

    bindMethods() {
      this.handleScroll = this.handleScroll.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleArrowClick = this.handleArrowClick.bind(this);
      this.updateScrollButtons = this.updateScrollButtons.bind(this);
      this.calculateTop = this.calculateTop.bind(this);
    }

    connectedCallback() {
      ['load', 'resize'].forEach(evt => window.addEventListener(evt, this.calculateTop));
      window.addEventListener('scroll', this.handleScroll);
      this.links.forEach(link => link.addEventListener('click', this.handleClick));

      if (this.scrollContainer) {
        Object.entries(this.scrollArrows).forEach(([direction, arrow]) => {
          arrow?.addEventListener('click', () => this.handleArrowClick(direction === 'left' ? -this.scrollAmount : this.scrollAmount));
        });
        this.scrollContainer.addEventListener('scroll', this.updateScrollButtons);
        this.updateScrollButtons();
      }
    }

    handleScroll() {
      this.calculateTop();

      const spaceFromTop = (this.getBoundingClientRect().top + window.scrollY) - (this.pageHeader.offsetHeight - 1);

      this.classList.toggle('fixed', window.scrollY >= spaceFromTop);

      const currentSection = this.sections.reduce((closest, section) => {
        if (!section) return closest;
        return window.scrollY >= section.offsetTop - this.additionalSpacing() ? section : closest;
      }, null);

      this.links.forEach(link => link.classList.remove('active'));
      if (currentSection) this.setActiveLink(currentSection);
    }

    setActiveLink(section) {
      const activeLink = this.querySelector(`a[href="#${section.id}"]`);
      if (!activeLink) return;

      activeLink.classList.add('active');
      if (this.tracker) {
        Object.assign(this.tracker.style, {
          left: `${activeLink.offsetLeft}px`,
          minWidth: `${activeLink.offsetWidth}px`
        });
      }
    }

    additionalSpacing() {
      return this.pageHeader.offsetHeight + this.offsetHeight + 32;
    }

    calculateTop() {
      if (this.wrapper) {
        this.wrapper.style.top = `${this.pageHeader.offsetHeight - 1}px`;
      }
    }

    handleClick(event) {
      event.preventDefault();
      const targetSection = document.querySelector(event.currentTarget.getAttribute('href'));
      if (targetSection) {
        window.scrollTo({
          top: targetSection.offsetTop - this.additionalSpacing(),
          behavior: 'smooth'
        });
      }
    }

    handleArrowClick(amount) {
      this.scrollContainer?.scrollBy({ left: amount, behavior: 'smooth' });
    }

    updateScrollButtons() {
      if (!this.scrollContainer) return;
      const { scrollLeft, clientWidth, scrollWidth } = this.scrollContainer;
      this.scrollArrows.left?.classList.toggle('disabled', scrollLeft <= 0);
      this.scrollArrows.right?.classList.toggle('disabled', scrollLeft + clientWidth >= scrollWidth);
    }
  }

  customElements.define('sticky-nav', StickyNav);
}
